import './i18n'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { AudioProvider } from './contexts/AudioContext'
import LanguageRouter from './components/LanguageRouter'
import AppRoutes from './routes'
import ScrollToTop from './components/ScrollToTop'
import { HelmetProvider } from 'react-helmet-async'
import MetaTags from './components/MetaTags'
import GradientBackground from './layouts/GradientBackground'
import { useLocation } from 'react-router-dom'
import { WaitlistProvider } from './contexts/WaitlistContext'

function AppWithGradient() {
  const location = useLocation()
  const segments = location.pathname.split('/').filter(Boolean)
  const pathAfterLang =
    segments.length > 0 && segments[0].length === 2
      ? '/' + segments.slice(1).join('/')
      : location.pathname
  return (
    <GradientBackground path={pathAfterLang}>
      <ScrollToTop />
      <AppRoutes />
    </GradientBackground>
  )
}

function App() {
  return (
    <HelmetProvider>
      <MetaTags />
      {/* Enable React Router v7 future flags to opt-in early and eliminate deprecation warnings */}
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AuthProvider>
          <AudioProvider>
            <LanguageRouter>
              <WaitlistProvider>
                <AppWithGradient />
              </WaitlistProvider>
            </LanguageRouter>
          </AudioProvider>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  )
}

/* Add scroll restoration */
window.history.scrollRestoration = 'manual'

export default App
